import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-center iq-title-box-2 wow fadeInUp',
    title: 'FEATURES_HEADER',
    titleIcon: ''
  };

  List1: any[] = [
    { title: 'HOSTED_IN_GERMANY' ,image: '../../assets/images/se-icons/servers.png', link: '#'},
    { title: 'CLUSER_ADVANTAGE' ,image:"../../assets/images/se-icons/cloud-it-department.png", link: '#'}
  ];
  List2: any[] = [
    { title: 'DATA_SECURITY' ,image: '../../assets/images/se-icons/data-security.png', link: '#'},
    { title: 'DB_CREATOR_SHORT_DESCRIPTION' ,image: '../../assets/images/se-icons/monitor.png', link: '#'}
  ];
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
  }
}
